module.exports = __webpack_public_path__ + "img/press_300.76d82eea.jpg";